import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';

@Component({
    selector: 'media',
    templateUrl: './media.component.html'
})
export class MediaComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}
